import {
  MissingChildrenSearchFormData,
  MissingChildrenSearchResult,
} from '@/modules/wnt/pages/services/MissingChildrenSearch/types';
import {
  CheckExtractVerificationFormData,
  CheckExtractVerificationResult,
  MissingCorpsesFormData,
  MissingCorpsesResult,
  MissingPassportFormData,
  MissingPassportResult,
  MissingPersonSearchFormData,
  MissingPersonSearchResult,
  MissingPhoneFormData,
  MissingPhoneResult,
  VehicleSearchFormData,
  VehicleSearchResult,
  WantedArtFormData,
  WantedArtResult,
  WantedIncapacitatedPersonsFormData,
  WantedIncapacitatedPersonsResult,
  WantedPersonSearchFormData,
  WantedPersonSearchResult,
  WantedWeaponFormData,
  WantedWeaponResult,
} from '@/modules/wnt/types';

import { SERVICE_CODES } from '@/lib/consts';

import { client } from '../../core/client';

import type { DataResponse } from '../../types';

export const wnt = {
  missingPassport: (
    formData: MissingPassportFormData,
    headers?: Headers,
  ): Promise<DataResponse<MissingPassportResult>> => {
    return client.post(`/user-requests/${SERVICE_CODES.MISSING_PASSPORT}/search`, formData, headers);
  },
  missingPhone: (formData: MissingPhoneFormData, headers?: Headers): Promise<DataResponse<MissingPhoneResult>> => {
    return client.post(`/user-requests/${SERVICE_CODES.MISSING_PHONE}/search`, formData, headers);
  },
  wantedWeapon: (formData: WantedWeaponFormData, headers?: Headers): Promise<DataResponse<WantedWeaponResult>> => {
    return client.post(`/user-requests/${SERVICE_CODES.WANTED_WEAPON}/search`, formData, headers);
  },
  wantedArt: (formData: WantedArtFormData, headers?: Headers): Promise<DataResponse<WantedArtResult[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.WANTED_ART}/search`, formData, headers);
  },
  wantedIncapacitatedPersons: (
    formData: WantedIncapacitatedPersonsFormData,
    headers?: Headers,
  ): Promise<DataResponse<WantedIncapacitatedPersonsResult[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.MISSING_INCAPACITATED_PERSONS}/search`, formData, headers);
  },
  missingCorpses: (
    formData: MissingCorpsesFormData,
    headers?: Headers,
  ): Promise<DataResponse<MissingCorpsesResult[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.MISSING_CORPSES}/search`, formData, headers);
  },
  wantedPersonSearchGet: (): Promise<DataResponse<WantedPersonSearchResult[]>> => {
    return client.get(`/user-requests/${SERVICE_CODES.WANTED_PERSON_SEARCH}/search`);
  },
  wantedPersonSearchPost: (
    formData: WantedPersonSearchFormData,
    headers?: Headers,
  ): Promise<DataResponse<WantedPersonSearchResult[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.WANTED_PERSON_SEARCH}/search`, formData, headers);
  },
  missingPersonSearchGet: (): Promise<DataResponse<MissingPersonSearchResult[]>> => {
    return client.get(`/user-requests/${SERVICE_CODES.MISSING_PERSON_SEARCH}/search`);
  },
  missingPersonSearchPost: (
    formData: MissingPersonSearchFormData,
    headers?: Headers,
  ): Promise<DataResponse<MissingPersonSearchResult[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.MISSING_PERSON_SEARCH}/search`, formData, headers);
  },
  missingChildrenSearchGet: (): Promise<DataResponse<MissingChildrenSearchResult[]>> => {
    return client.get(`/user-requests/${SERVICE_CODES.MISSING_CHILDREN_SEARCH}/search`);
  },
  missingChildrenSearchPost: (
    formData: MissingChildrenSearchFormData,
    headers?: Headers,
  ): Promise<DataResponse<MissingChildrenSearchResult[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.MISSING_CHILDREN_SEARCH}/search`, formData, headers);
  },
  vehicleSearch: (formData: VehicleSearchFormData, headers?: Headers): Promise<DataResponse<VehicleSearchResult>> => {
    return client.post(`/user-requests/${SERVICE_CODES.VEHICLE_SEARCH}/search`, formData, headers);
  },
  checkExtractVerification: (
    formData: CheckExtractVerificationFormData,
    headers?: Headers,
  ): Promise<DataResponse<CheckExtractVerificationResult>> => {
    return client.post(`/user-requests/${SERVICE_CODES.CHECK_EXTRACT_VERIFICATION}/search`, formData, headers);
  },
};
